<template>
  <Input
    ref="inputRef"
    v-model="formattedValue"
    :label="label ? $t(label) : label"
    :placeholder="placeholder ? $t(placeholder) : placeholder"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
    :validation-value="numberValue"
    validate-on="input lazy"
    :rules="rules"
    :hint="hint"
    persistent-hint
  />
</template>

<script setup>
import {watch} from 'vue';
import { useCurrencyInput } from 'vue-currency-input';
import Input from "@intec/vue-components/form/Input.vue";

const props = defineProps({
  label: String,
  placeholder: String,
  disabled: Boolean,
  modelValue: Number,
  rules: Array,
  required: Boolean,
  readonly: Boolean,
  hint: String,
  min: Number,
  max: Number,
  currencyDisplay: 'symbol' | 'narrowSymbol' | 'code' | 'name' | 'hidden'
}, {
  currencyDisplay: 'symbol'
});

const options = {
  locale: 'RU',
  currency: 'USD',
  precision: 2,
  distractionFree: false,
  currencyDisplay: props.currencyDisplay,
  valueRange: {
    min: props.min ?? 0,
    max: props.max ?? 999999999999.99
  }
};

const { inputRef, formattedValue, numberValue, setValue, setOptions } = useCurrencyInput(options, false);

watch(() => props.modelValue,
  (value) => {
    setValue(value);
  },
);

watch(() => props.min,
  (value) => {
    setOptions({
      ...options,
      valueRange: {
        min: props.min,
        max: props.max,
      }
    });
  },
);

const emit = defineEmits(['update:modelValue']);

watch(() => props.max,
  (value) => {
    setOptions({
      ...options,
      valueRange: {
        min: props.min,
        max: props.max,
      }
    });
  },
);

watch(numberValue, (newValue) => {
  emit('update:modelValue', newValue);
});

</script>
<style scoped>
.disabled :deep(.v-field) {
  background-color: rgb(var(--disabled-grey));
  transition: background-color 0.5s ease;
  pointer-events: none;
}
:deep(.v-input__details){
  opacity: inherit;
}
</style>
